import { type FC } from "react";
import { ArrowRight } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import peopleBackground from "@/shared/assets/backgrounds/people-background.png";
import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

interface InviteLandingOptions {
  inviterName: string;
  decedentName: string;
}

export function createInviteLanding({
  inviterName,
  decedentName,
}: InviteLandingOptions): FC<FlowCustomComponentProps> {
  const InviteLanding: FC<FlowCustomComponentProps> = ({ onComplete }) => {
    return (
      <div className="flex max-w-[840px] items-center justify-center gap-10 self-stretch flex-col sm:flex-row">
        <div className="shrink-0">
          <img
            src={peopleBackground}
            alt="Families using Elayne"
            className="aspect-[150/157] w-full rounded-lg object-cover sm:w-[400px]"
          />
        </div>

        <div className="flex flex-1 flex-col items-start justify-center gap-10">
          <div>
            <h2 className="w-full">
              {inviterName} has invited you to help settle {decedentName}&apos;s estate
            </h2>
            <p className="mt-4">
              We're here to make this process easier by helping you track assets, manage debts, and
              stay organized throughout.
            </p>
          </div>

          <Button variant="brand" rounded={true} onClick={() => onComplete()} className="w-full">
            Accept invite <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    );
  };

  return InviteLanding;
}
